// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.src-shared-components-CustomLoader-CustomLoader-module__loader {
  width: 100%;
  height: 100%;
  align-items: center;
  justify-content: center;
}`, "",{"version":3,"sources":["webpack://./src/shared/components/CustomLoader/CustomLoader.module.scss"],"names":[],"mappings":"AAAA;EACE,WAAA;EACA,YAAA;EACA,mBAAA;EACA,uBAAA;AACF","sourcesContent":[".loader {\n  width: 100%;\n  height: 100%;\n  align-items: center;\n  justify-content: center;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"loader": `src-shared-components-CustomLoader-CustomLoader-module__loader`
};
export default ___CSS_LOADER_EXPORT___;
